import { Component } from '@angular/core';
import {BooxSessionService} from "lib-boox";
import {RouterLink} from "@angular/router";
import {NgIf} from "@angular/common";
import {HeroAvatarService} from "lib-hero";

@Component({
  selector: 'host-profile',
  standalone: true,
  imports: [
    RouterLink,
    NgIf
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {
  private _avatar : string|null = null;
  public get avatar() : string|null {
    return this._avatar;
  }

  public get profileName () : string {
    return this.sessionServ.session?.first_name + ' ' + this.sessionServ.session?.last_name;
  }

  constructor(
    private avatarServ: HeroAvatarService,
    private sessionServ: BooxSessionService,
  ){
    this.avatarServ.load().subscribe((avatar) => this._avatar = avatar);
  }
}
